import TextInput from "../../../components/files/TextInput";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import http from "../../../http";
import { setShowLoading } from "../../../store/sysSlice";
import { useDispatch } from "react-redux";
import { apiUrl } from "../../../config/settings";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { onlyNumber } from "../../../utils/validations";
import { endpointNameList } from "../const";
import { Stack } from "@mui/material";
import SwitchInput from "../../../components/files/SwitchInput";
import useDataManager from "../../../hooks/useDataManager";
import CustomDialog from "components/CustomDialog";

const Details = ({ item, setItem, setList, list, clientId }) => {
  const { addItem, editItem } = useDataManager();
  const dispatch = useDispatch();
  const { bt } = useBizTypeTranslation();
  const { reset, handleSubmit, control, formState: { errors } } = useForm();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (item && item !== "new") {
      reset(item);
      setData(item);
    }
  }, [item]);

  const onClose = () => {
    setItem(false);
  };

  const onSubmit = (values) => {
    dispatch(setShowLoading(true));

    let data = {
      name: values.name,
      desc: values.desc,
      client: clientId,
    };

    if (item?.id !== "new") {
      http
        .patch(`${apiUrl}/${endpointNameList}/${item?.id}`, data)
        .then((res) => {
          dispatch(setShowLoading(false));
          data.id = item?.id;
          const newList = editItem(data, list);
          setList(newList);
          onClose();
        })
        .catch((error) => {
          dispatch(setShowLoading(false));
        });
    } else {
      http
        .post(`${apiUrl}/${endpointNameList}`, data)
        .then((res) => {
          dispatch(setShowLoading(false));
          data.id = res?.data?.itemId;
          const newList = addItem(data, list);
          setList(newList);
          // getData();
          onClose();
        })
        .catch((error) => {
          dispatch(setShowLoading(false));
        });
    }
  };

  if (!data && item?.id !== "new") {
    return;
  }

  return (
    <CustomDialog
      open={item ? true : false}
      onClose={onClose}
      title='DETAILS'
      closeBtn='CLOSE'
      actionBtn={{ title: 'SAVE', onClick: () => handleSubmit(onSubmit)() }}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack width="100%" minWidth={{ xs: "auto", sm: 350 }} gap={2}>
          <TextInput
            name="name"
            errors={errors}
            required
            title="NAME"
            width="100%"
            control={control}
          />

          <TextInput
            rows={4}
            errors={errors}
            name="desc"
            width="100%"
            title="DESC"
            control={control}
          />
        </Stack>
      </form>
    </CustomDialog>
  );
};
export default Details;
